import styled from "styled-components";

import { useIsSupderDuper } from "Flocknote/stateHooks";

import { useOtherNetworks } from "CrossFeatureComponents/MemberToolbar/API/queryHooks";
import { LogoutButton } from "CrossFeatureComponents/MemberToolbar/components/LogoutButton";
import { Divider } from "CrossFeatureComponents/MemberToolbar/components/shared";
import { SetLanguage } from "CrossFeatureComponents/MemberToolbar/components/shared/SetLanguage";

import FnrStaggeredEntry from "UI/FnrStaggeredEntry";

import { OtherNetworks } from "../OtherNetworks";

import EditProfileButton from "./EditProfileButton";
import { useIsOnProfilePage } from "./stateHooks";

const BottomSection = () => {
  const isOnProfilePage = useIsOnProfilePage();
  const isSuperDuper = useIsSupderDuper();
  const hasOtherNetworks = useOtherNetworks().length > 0;

  return (
    <RowWrapper>
      <FnrStaggeredEntry variant="fade" noInit show>
        {hasOtherNetworks && <OtherNetworks key="otherNetworks" />}
        {hasOtherNetworks && <PaddedDivider marginX={-5} key="divider" />}
      </FnrStaggeredEntry>
      <Wrapper>
        {!isOnProfilePage && !isSuperDuper && <EditProfileButton />}
        <RightTools>
          <SSetLanguage />
          <LogoutButton />
        </RightTools>
      </Wrapper>
    </RowWrapper>
  );
};

const PaddedDivider = styled(Divider)`
  margin-top: 8px;
  margin-bottom: 8px;
`;

const RowWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const SSetLanguage = styled(SetLanguage)`
  & > button > div {
    height: 28px;
    width: 28px;
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 4px;
  align-items: center;
  margin-top: 4px;
`;

const RightTools = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: right;
  gap: 4px;
`;

export default BottomSection;
